import React from 'react';
import { getContext } from 'common';
import Styled from './styles';

export interface FieldProps {
  theme?: any;
  hasButton?: boolean;
  variant?: 'outlined' | 'underlined';
  /** To pass all other props to an unknown element. */
  [x:string]: any;
}

/** Internal component handling text field style */
const Field = React.forwardRef<HTMLElement, FieldProps>((props: FieldProps, ref) => getContext(({ RTL }) => {
  const {
    hasButton,
    ...resolvedWrapperProps
  } = props;

  return (
    <Styled.Field {...resolvedWrapperProps} RTL={RTL} ref={ref} />
  );
}));

Field.displayName = 'Field';

Field.defaultProps = {
  theme: {},
  hasButton: false,
  variant: 'outlined',
};

export default Field;
